import { Fragment, useMemo } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import { StickyHeader, FiltersActivity } from '../../components'
import messages from '../../messages'
import {
  SearchTypesSelector,
  SearchTypesMobileSelector,
  ActivityWrapper,
  SearchMap,
  BackListViewComponent,
  MobileFilters,
  SortingFilters,
} from '../../components/search'
import { setNumberOfTrips } from '../../actions/search-actions'
import { TemporaryBanner } from '../../components/popups/TemporaryBanner'
import {
  searchFiltersHook,
  searchOnInitHook,
} from '../../components/search/hooks'

import PropTypes from 'prop-types'

import { filtersKeys, filtersToClean } from './../searchData'

function DiveCentersSearch({
  searchFilters,
  model,
  pk,
  point,
  activityType,
  selectedCurrency,
  orderingList,
  isNearBy,
  title,
  inTitle,
  numberOfTrips,
  locationCoordinates,
  isWidget,
  filters,
  trustpilotLocale,
  setNumberOfTrips,
  countryCode,
}) {
  const intl = useIntl()
  const activityAPIUrl = useMemo(
    () => model ? `search/autosuggest/${model.toLowerCase()}/${pk}/dive-centers/` : '',
    [model, pk],
  )
  const {
    transformedFilters,
    filtersCount,
    updateParams,
    updateOrdering,
    triggerApi,
    clearSelectedFilters,
    clearDates,
    showListView,
  } = searchFiltersHook(filtersKeys, filtersToClean, 'dive-center')
  searchOnInitHook(filtersKeys)
  const isMapView = useMemo(() => transformedFilters.view === 'map', [
    transformedFilters.view,
  ])

  return (
    <div className='search-page-la search-page-dr'>
      <div className='hide-map-overlap'>
        {isMapView && <BackListViewComponent onClose={showListView} />}
        <StickyHeader typeOfSearch={activityType} locationTitle={title} />
        <ReactTooltip type='dark' effect='solid' id='global' />
        <div className={`search-wrapper ${isMapView ? 'full-width' : ''}`}>
          <div className={`main-content ${isWidget && 'widget-search'}`}>
            <div className='results-head results-sort-wrapper display-flex content-s-b items-center'>
              <h1 className='hidden-xs'>
                {isNearBy ? (
                  <FormattedMessage
                    id='search.title.dive_center.near_by'
                    values={{
                      qty: numberOfTrips,
                    }}
                    defaultMessage='{ qty, plural, one {# dive center } other {# dive centers } } nearby (50km radius)'
                  />
                ) : (
                  <FormattedMessage
                    id='search.title.dive_center'
                    values={{
                      qty: numberOfTrips,
                      location: inTitle,
                    }}
                    defaultMessage='{ qty, plural, one {# dive center } other {# dive centers } } { location }'
                  />
                )}
              </h1>

              {!isWidget && (
                <div className='shop-types-search-page'>
                  <SearchTypesSelector
                    activePage={window.typesData && window.typesData.activePage}
                  />
                  <SearchTypesMobileSelector
                    activePage={window.typesData && window.typesData.activePage}
                  />
                </div>
              )}

              <SortingFilters
                updateOrdering={updateOrdering}
                orderingValue={transformedFilters.ordering}
                sortByItems={orderingList}
              />
              {isNearBy && !isMapView && !isWidget && (
                <TemporaryBanner
                  id='use_map_tip'
                  text={intl.formatMessage(messages.use_map_tip, {
                    strong: (str) => <strong>{str}</strong>,
                  })}
                />
              )}
            </div>
            {!isWidget && (
              <FiltersActivity
                model={model}
                pk={pk}
                triggerApi={triggerApi}
                isWidget={isWidget}
                selectedFilters={searchFilters}
                items={filters}
                title={title}
                updateParams={updateParams}
                clearDates={clearDates}
                clearSelectedFilters={clearSelectedFilters}
                trustpilotLocale={trustpilotLocale}
                filtersCount={filtersCount}
                selectedCurrency={selectedCurrency}
                activityType={activityType}
                isDiveCenter
                activityUrl={activityAPIUrl}
              />
            )}
            <div className='result-list'>
              {isMapView ? (
                <SearchMap
                  searchType={activityType}
                  isActivityEndpoint
                  sortKey='pk'
                  selectedParams={transformedFilters}
                  showListView={showListView}
                  countryCode={countryCode}
                  initLocation={locationCoordinates}
                />
              ) : (
                <Fragment>
                  {!isWidget && (
                    <MobileFilters
                      filtersCount={filtersCount}
                      updateParams={updateParams}
                      handleSortSelect={updateOrdering}
                      sortOptions={orderingList}
                      selectedSorting={transformedFilters.ordering}
                    />
                  )}
                  <ActivityWrapper
                    setNumberOfItems={setNumberOfTrips}
                    selectedParams={transformedFilters}
                    getNewData={triggerApi}
                    isDiveCenter
                    model={model}
                    numberOfTrips={numberOfTrips}
                    pk={pk}
                    gPlacePoint={point}
                    point={transformedFilters.point}
                    distance={transformedFilters.distance}
                    activityType={activityType}
                    selectedCurrency={selectedCurrency}
                  />
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({
  isNearBy,
  searchFilters,
  selectedCurrency,
  numberOfTrips,
}) => ({
  isNearBy,
  searchFilters,
  selectedCurrency,
  numberOfTrips,
})

export default connect(mapStateToProps, { setNumberOfTrips })(
  DiveCentersSearch,
)

DiveCentersSearch.propTypes = {
  searchFilters: PropTypes.object,
  model: PropTypes.string,
  pk: PropTypes.string,
  point: PropTypes.object,
  activityType: PropTypes.string,
  selectedCurrency: PropTypes.string,
  orderingList: PropTypes.array,
  isNearBy: PropTypes.bool,
  title: PropTypes.string,
  inTitle: PropTypes.string,
  numberOfTrips: PropTypes.number,
  locationCoordinates: PropTypes.object,
  isWidget: PropTypes.bool,
  filters: PropTypes.array,
  trustpilotLocale: PropTypes.string,
  setNumberOfTrips: PropTypes.func,
  countryCode: PropTypes.string,
}
